import React from 'react';
import './AppLoader.css';

/**
 * AppLoader - Full-screen loading state shown during initial app bootstrap
 * Displays while SiteSettings are being fetched from the API
 */
const AppLoader = () => {
  return (
    <div className="app-loader">
      <div className="app-loader__content">
        {/* Animated logo or brand mark */}
        <div className="app-loader__logo">
          <div className="app-loader__logo-ring"></div>
          <div className="app-loader__logo-ring app-loader__logo-ring--2"></div>
          <div className="app-loader__logo-core"></div>
        </div>
        
        {/* Loading text */}
        <h2 className="app-loader__title">OKO Solutions</h2>
        <p className="app-loader__subtitle">Loading your experience...</p>
        
        {/* Progress bar */}
        <div className="app-loader__progress">
          <div className="app-loader__progress-bar"></div>
        </div>
      </div>
      
      {/* Animated background gradient */}
      <div className="app-loader__bg"></div>
    </div>
  );
};

export default AppLoader;
